const linkTypes = ['play', 'info', 'event', 'download', 'webinar', 'brochure']

export default linkTypes



// WEBPACK FOOTER //
// ./helpers/linkTypes.js